// extracted by mini-css-extract-plugin
module.exports = {"card":"_2kciMG","image":"_2Wu3QC","title":"_3Z2Ifi","subTitle":"_2-26dZ"};